import { h } from 'vue';

export default {
    // functional: true,

    render()
    {
        return h(
            'h3',

            {
                class: 'vh-modal-title',
            },

            this.$slots
        );
    },
};
